export const patternMail = () => /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;

export const patternNumeric = (minLength, maxLength) => {
  if(maxLength !== undefined && maxLength !== null) {
    return new RegExp(`[0-9]{${minLength},${maxLength}}`);
  } else {
    return new RegExp(`[0-9]{${minLength}}`);
  }
}